export const TABLE_FORM_ROW_HEIGHT = 58
export const TABLE_FORM_CELL_WIDTH = 120
